import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-progress-report-table',
  templateUrl: './dialog-progress-report-table.component.html',
  styleUrls: ['./dialog-progress-report-table.component.scss']
})

export class DialogProgressReportTableComponent implements OnInit {



  mpcForm!: FormGroup;
  bipcForm!: FormGroup;
  mpcshow: boolean;
  bipcshow: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, private dialogRef: MatDialogRef<DialogProgressReportTableComponent>) { }
  ngOnInit(): void {
    this.mpcForm = this.fb.group({
      maths: ['', Validators.required],
      mathMaxMarks: ['', Validators.required],
      topMaths: ['', Validators.required],
      avgMaths: ['', Validators.required],

      physics: ['', Validators.required],
      phyMaxMarks: ['', Validators.required],
      topPhy: ['', Validators.required],
      avgPhy: ['', Validators.required],

      chemistry: ['', Validators.required],
      cheMaxMarks: ['', Validators.required],
      topChem: ['', Validators.required],
      avgChem: ['', Validators.required],

      mRank: ['', Validators.required],
      pRank: ['', Validators.required],
      cRank: ['', Validators.required],
      secRank: ['', Validators.required],
      stateRank: ['', Validators.required],
      totalMaxMarks: ['', Validators.required]

    });

    this.bipcForm = this.fb.group({
      buildingName: ['', Validators.required],
      poNo: ['', Validators.required],
      majorCategory: ['', Validators.required],
      minorCategory: ['', Validators.required],
      organization: ['', Validators.required],
      blockNo: ['', Validators.required],
      blockName: ['', Validators.required],
      floorNo: ['', Validators.required],
      roomType: ['', Validators.required],
      roomNo: ['', Validators.required],
      noofAssets: ['', Validators.required],
    });
    console.log('DATA_MARKS', this.data);
    this.onPatchValue(this.data);
  }

  onPatchValue(data: any) {
    console.log('patch_data', this.data);
    if (this.data.group == 'MPC') {
      this.mpcshow = true;
      this.bipcshow = false;
      this.mpcForm.patchValue({
        maths: this.data.maths,
        mathMaxMarks: this.data.mathMaxMarks,
        topMaths: this.data.topMaths,
        avgMaths: this.data.avgMaths,

        physics: this.data.physics,
        phyMaxMarks: this.data.phyMaxMarks,
        topPhy: this.data.topPhy,
        avgPhy: this.data.avgPhy,

        chemistry: this.data.chemistry,
        cheMaxMarks: this.data.cheMaxMarks,
        topChem: this.data.topChem,
        avgChem: this.data.avgChem,

        mRank: this.data.mRank,
        pRank: this.data.pRank,
        cRank: this.data.cRank,
        secRank: this.data.secRank,
        stateRank: this.data.stateRank,
        totalMaxMarks: this.data.totalMaxMarks

      });
    }
    else if (this.data.group == 'BIPC') {
      this.bipcshow = true;
      this.mpcshow = false;
      this.bipcForm.patchValue({
        // buildingName: this.data.buildingName,
        // poNo: this.data.assetPoNo,
        // majorCategory: this.data.majorCategoryName,
        // minorCategory: this.data.minorCategoryName,
        // organization: this.data.orgName,
        // blockNo: this.data.blockNo,
        // blockName: this.data.blockName,
        // floorNo: this.data.floorNo,
        // roomType: this.data.roomType,
        // roomNo: this.data.roomNo,
        // noofAssets: this.data.totalAssets
      });

    }
    else {
      console.log('NO DATA FOUND');

    }


  }

  onNoClick() {
    this.dialogRef.close();
  }
}
